<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

@if (!isEnabled) {
  <profile-pds-p-text p-text>
    <span aria-hidden="true">{{ timerLabel }}</span>
    <span class="profile:sr-only" aria-live="polite" aria-atomic="true">{{ announcement }}</span>
    @if (tooltipInfoText) {
      <profile-pds-p-popover p-popover [description]="tooltipInfoText"></profile-pds-p-popover>
    }
  </profile-pds-p-text>
}
@if (isEnabled) {
  <profile-pds-p-button-pure p-button-pure icon="none" [disabled]="disabled" (click)="clickHandler()" type="button">
    {{ requestCodeTimerLabel }}
  </profile-pds-p-button-pure>
}
